import { configureStore } from '@reduxjs/toolkit';
import calloutReducer from 'app/features/callout/calloutSlice';
import menuReducer from 'app/features/menu/menuSlice';
import notificationReducer from 'app/features/notification/notificationSlice';
import cardReducer from 'app/features/card/cardSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const store = configureStore({
    reducer: {
        notifications: notificationReducer,
        menu: menuReducer,
        callouts: calloutReducer,
        cards: cardReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Infere os tipos para `RootState` and `AppDispatch` a partir do próprio 'store'.
export type RootState = ReturnType<typeof store.getState>;

// Infere os tipos.
// Exemplo: { notifications: NotificationState; }
type AppDispatch = typeof store.dispatch;


// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
